import { FC } from 'react';
import { cn } from '@repo/ui/lib/utils';
import { X } from 'lucide-react';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { type CandidateMedia } from '@repo/ui/hooks';
import { SpotlightMedia } from '../../spotlight-media/component';
import {
  Sheet,
  SheetDescription,
  SheetHeader,
  SheetOverlay,
  SheetPortal,
  SheetPrimitive,
  sheetVariants,
} from '@repo/ui/components/ui/sheet';

export const MobileZoom: FC<{
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  mediaAlt?: string;
  media: CandidateMedia;
}> = ({ open, onOpenChange, mediaAlt, media }) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetPortal>
        <SheetOverlay className="bg-black/80 backdrop-blur-2xl" />
        <SheetPrimitive.Content
          className={cn(
            sheetVariants({ side: 'right' }),
            'w-full p-0 bg-transparent border-l-0',
          )}
        >
          <SheetHeader>
            <VisuallyHidden>
              <SheetDescription>Media lightbox mobile zoom</SheetDescription>
            </VisuallyHidden>
            <SheetPrimitive.Close asChild>
              <section className="fixed top-1.5 right-4 z-20">
                <button className="flex items-center justify-center w-10 h-10 bg-white/[0.90] text-cn-muted-foreground rounded-full">
                  <X className="w-4 h-4" />
                </button>
              </section>
            </SheetPrimitive.Close>
          </SheetHeader>
          <section className="w-full h-full">
            <TransformWrapper>
              <TransformComponent
                wrapperClass="!w-full !h-full"
                contentClass="!w-full !h-full"
              >
                <SpotlightMedia
                  media={media}
                  imageMediaAlt={mediaAlt}
                  isVideoMuted={true}
                  showPlayPauseVideoControl={false}
                  enableDesktopZoom={false}
                  videoAutoplay={false}
                  showNavigationControls={false}
                />
              </TransformComponent>
            </TransformWrapper>
          </section>
        </SheetPrimitive.Content>
      </SheetPortal>
    </Sheet>
  );
};
